import React from 'react';
import Reflux from 'reflux';
import {Button, Row, Col, Modal, Select, Input, message} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView} from '../../components';
import {
    getGouXiaoUnitList,
    getSpecialOrderDetail, getSpecialType
} from '../../service/specialOrder';
import moment from "moment";

class SpecialOrderDetail extends Reflux.Component {
    constructor(props) {
        super(props);
        this.channelData = window.sessionStorage.getItem('cur_channel') || '{}';
        this.state = {
            channelCode: this.channelData.split('|')[1] || '',
            opts: ['特殊订单'],
            selectedRowsAllKeys: [],
            selectedRowKeys: [],
            dataSource: [],
            gouxiaoUnitList: [],
            rows: [],
            rowsOutSide: [],
            specialTypeList: [],
            total: 1,
            dataSourceTotal: 1,
            userName: JSON.parse(window.localStorage.getItem('login_user_information')).userName,
            searchObj: {
                s: 10,
                p: 1
            },
            detail: [],
            visible: false,
            loading: false,
        };
        this.pageChange = this.pageChange.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
        this.getSpecialTypeList = this.getSpecialTypeList.bind(this);
    };

    /*路径跳转*/
    goView(url) {
        hashHistory.push(url);
    };

    goBack() {
        hashHistory.goBack();
    };


    pageChange(page, pageSize) {
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}});
    }


    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
    }

    componentWillMount() {
        let self = this;
        this.getSpecialTypeList();
        let channelCode = this.state.channelCode;
        getGouXiaoUnitList({channelCode: channelCode, s: 999}).then(res => { //购货单位
            if (res.status) {
                const data = res.data || [];
                let arr = [];
                for (let i = 0; i < data.length; i++) {
                    let x = data[i];
                    arr.push({
                        text: x.name,
                        value: x.id
                    })
                }
                this.state.detail.salesUnitId = res.data[0].id;
                self.setState({gouxiaoUnitList: arr}, () => {
                    const id = this.props.params.id;
                    console.log(id);
                    if (id) {
                        this.getDetail(id);
                    }
                })
            }
        });
    }

    componentDidMount() {
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    getSpecialTypeList() {
        getSpecialType().then(res => {
            if (res.code === 200) {
                const data = res.data || [];
                let arr = [];
                for (let i = 0; i < data.length; i++) {
                    let x = data[i];
                    arr.push({
                        text: x.name,
                        value: x.sKey
                    })
                }
                this.setState({specialTypeList: arr});
            }
        })
    }

    getDetail(id) {
        getSpecialOrderDetail(id).then(res => {
            if (res.code === 200) {
                const data = res.data;
                let allAmount = 0;
                data.lineList.forEach(itm => {
                    itm.amount = itm.quantity * itm.price;
                    allAmount = allAmount + itm.quantity * itm.price;
                })
                let arr = [];
                this.setState({
                    detail: data,
                    rows: data.lineList,
                    allAmount: allAmount,
                    submitParam: {
                        ...this.state.submitParam,
                        custId: data.custId,
                        salesUnitId: data.salesUnitId,
                        orderNumber: data.orderNumber
                    }
                });
                if (data.lineList) {
                    data.lineList.forEach(line => {
                        arr.push(line.itemNum);
                    })
                }
                this.setState({selectedRowsAllKeys: arr});
            }
        });
    }


    render() {
        const {
            opts, rows, gouxiaoUnitList, total, searchObj, detail, specialTypeList, allAmount
        } = this.state;
        const tableViewProps = {
            loading: false,//更新表格数据中
            rowKey: 'itemNum',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '物料编码',
                    dataIndex: 'itemNum'
                },
                {
                    title: '物料描述',
                    dataIndex: 'itemDesc'
                },
                {
                    title: '数量',
                    dataIndex: 'quantity'
                },
                {
                    title: '单价',
                    dataIndex: 'price'
                },
                {
                    title: '金额',
                    dataIndex: 'amount'
                }
            ],
            rows
        };

        return <div>
            <DmsTab options={opts} defaultKey={0}>
                <Button onClick={this.goBack}>返回</Button>
            </DmsTab>
            <div className="dms-table-box">
                <Row style={{"height": "35px"}}>
                    <Col span={6}>
                        <label>订单日期：</label>
                        <span>{moment(parseInt(detail.orderDate)).format('YYYY-MM-DD')}</span>
                    </Col>
                    <Col span={6}>
                        <label>订单编号：</label>
                        <span>{detail.orderNumber}</span>
                    </Col>
                    <Col span={6}>
                        <label>客户名称：</label><span>{this.state.userName}</span>
                    </Col>
                    <Col span={6}>
                        <label className="ant-form-item-required">购货单位：</label>
                        <Select
                            value={detail.salesUnitId + ''}
                            placeholder="请选择购货单位"
                            disabled={true}
                            style={{minWidth: 250}}
                        >
                            {
                                gouxiaoUnitList.map((item, index) => {
                                    return <Select.Option key={item.value + ''}
                                                          value={item.value + ''}>{item.text}</Select.Option>
                                })
                            }
                        </Select>
                    </Col>
                </Row>
                <Row style={{"height": "35px"}}>
                    <Col>
                        <Col span={6}>
                            <label>价格单号：</label><span>{detail.specialCode}</span>
                        </Col>
                    </Col>
                    <Col>
                        <Col span={6}>
                            <label>合同/订单名称：</label><span>{detail.contractOrderName}</span>
                        </Col>
                    </Col>
                    <Col>
                        <Col span={6}>
                            <label>结算对应号：</label><span>{detail.settleOrder}</span>
                        </Col>
                    </Col>
                    <Col span={6}>
                        <label className="ant-form-item-required">订单类型：</label>
                        <Select
                            value={detail.specialType + ''}
                            placeholder="请选择订单类型"
                            disabled={true}
                            style={{minWidth: 250}}
                        >
                            {
                                specialTypeList.map((item, index) => {
                                    return <Select.Option key={item.value + ''}
                                                          value={item.value + ''}>{item.text}</Select.Option>
                                })
                            }
                        </Select>
                    </Col>

                </Row>
                <Row style={{"height": "35px"}}>
                    <Col>
                        <Col span={6}>
                            <label>订单反馈：</label><span>{detail.feedback}</span>
                        </Col>
                    </Col>
                    <Col>
                        <Col span={6}>
                            <label>备注：</label><span>{detail.remark}</span>
                        </Col>
                    </Col>
                </Row>
            </div>
            <div>
                <DmsTab className="white-bg no-border" options={['订单物料']} defaultKey={0}/>
                <div className="dms-table-box">
                    <TableView {...tableViewProps} />
                    <div className="order_amount" style={{marginTop: 20}}>
                        <p><span className="right">{'总金额：￥' + allAmount}</span></p>
                    </div>
                </div>
            </div>
        </div>
    }
}

export default withRouter(SpecialOrderDetail);


// WEBPACK FOOTER //
// ./src/routes/specialOrder/detail.js